import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function PersonIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M16.33 17.49v-1.67c0-1.84-1.49-3.33-3.33-3.33H6.33C4.49 12.49 3 13.98 3 15.82v1.67m6.66-8.33a3.33 3.33 0 1 0 0-6.66 3.33 3.33 0 0 0 0 6.66Z"
      />
    </Icon>
  );
}
